module.exports = __webpack_public_path__ + "img/page4-3.8f8473b0.png";